import { FXType } from "../../../../types/fx.type";

/**
 * Determine the taker is buy base currency
 * - Base currency always on the left side of FX
 * - Taker is user, not bank
 * - e.g. USDMYR, USD is base currency, if user selected USD as from currency, MYR as to currency, then the result would be FALSE
 * @param {string} sourceCurrency - From currency.
 * @param {FXType} fxObject - FX data object.
 * @return {boolean} taker is trying to buy the base currency or not.
 */
const isTakerBuyBase = (sourceCurrency: string, fxObject: FXType): boolean => {
	return sourceCurrency === fxObject.currencies[1];
};

export default isTakerBuyBase;
